/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitarParticipacaoAliases {
  CARD_0 = 'card-0',
  CHECKLIST_0 = 'checklist-0',
  CHECKLIST_1 = 'checklist-1',
  CHECKLIST_2 = 'checklist-2',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FETCH_2 = 'fetch-2',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FORM = 'form',
  LAYOUT_SOLICITAR_PARTICIPACAO = 'layout-solicitar-participacao',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_2 = 'mapper-2',
  PANEL_0 = 'panel-0',
  PHONE_NUMBER = 'phone-number',
  TEXT_AREA_0 = 'text-area-0',
}
export { SolicitarParticipacaoAliases };
